export function initializeYouTubePlayer(callback) {
    const bgVideoID = document.querySelector('.js-background-video').getAttribute('data-video');

    const playerOptions = {
        autoplay: 1,
        mute: 1,
        autohide: 1,
        modestbranding: 1,
        showinfo: 0,
        controls: 0,
        disablekb: 1,
        enablejsapi: 1,
        iv_load_policy: 3,
        listType: 'playlist',
        loop: 1, // Correct loop parameter
        playlist: bgVideoID, // Add this line to enable looping
        setSize: { width: '100%', height: '100%' },
    };

    window.onYouTubeIframeAPIReady = function() {
        window.ytPlayer = new YT.Player('yt-player', {
            videoId: bgVideoID,
            playerVars: playerOptions,
            events: {
                'onReady': function(event) {
                    event.target.playVideo();
                    if (callback) callback();
                },
                onStateChange: function(e) {
                    if (e.data === YT.PlayerState.ENDED) {
                        window.ytPlayer.playVideo(); 
                    }
                }
            }
        });
    };

    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}
